<template>
  <div class="loginPage">
    <v-row dense no-gutters class="auth-row">
      <v-col cols="12" sm="12" md="6" class="custom-height">
        <div class="auth-light-version">
          <div class="logo">
            <v-img :width="logoWidth" :height="logoHeight" :src="logoSrc"></v-img>
          </div>

          <h3>Log in</h3>

          <v-form class="deposit-form password-field">
            <div class="form-details">
              <fieldset>
                <legend>Email</legend>
                <v-text-field :value="loginInfo.email" @input="LOGIN_EMAIL" placeholder="Enter your Email" single-line
                  solo hide-details class="custom-select" autocomplete="false" aria-autocomplete="none"></v-text-field>
              </fieldset>

              <fieldset>
                <legend>Password</legend>
                <v-text-field placeholder="Enter Here" :value="loginInfo.password" @input="LOGIN_PASSWORD"
                  :append-icon="viewPassword ? 'mdi-eye' : 'mdi-eye-off'" :type="viewPassword ? 'text' : 'password'"
                  counter @click:append="VIEW_PASSWORD" single-line solo hide-details class="custom-select"
                  autocomplete="false" aria-autocomplete="none"></v-text-field>
              </fieldset>

              <div class="forget-link align-center d-flex justify-space-between ma-0 mb-5">
                <v-checkbox v-model="ex4" :ripple="false" label="Remember Me" color="#039DE9" value="red" hide-details
                  class="checkbox-style pa-0 ma-0"></v-checkbox>

                <router-link to="/forget-password">Forget Password?</router-link>
              </div>

              <v-btn class="ma-0 text-capitalize btn-account" color="#039DE9" tile block elevation="0"
                :disabled="!validToLogin" :loading="loading" @click.prevent="userLogin">
                Log in
              </v-btn>

              <div class="another-link">
                <p>
                  Don’t have any account?
                  <router-link to="/create-account">Create new account</router-link>
                </p>
              </div>
            </div>
          </v-form>

        </div>
      </v-col>

      <v-col cols="12" sm="12" md="6" class="image-col">
        <div class="image-content">
          <h3 class="mb-2">High Risk Investment Warning:</h3>
          <p>
            Trading Leveraged Products such
            as Forex and Derivatives may not be suitable for all investors as they carry a
            high degree of risk to your capital. Please ensure that you fully understand
            the risks involved, taking into account your investments objectives and level
            of experience, before trading, and if necessary, seek independent advice.
          </p>
          <social-icons :info="genInfo"></social-icons>
        </div>

        <div class="image-container">
          <v-img src="@/assets/auth.png" class="zoom-animate-full image-full"></v-img>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import LanguageMenu from "@/components/TopBar/LanguageMenu.vue";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";

import { AUTHENTICATION__ACTIONS, PUBLIC_LOGIN__ACTIONS } from "@/store/action-types";
import { AUTHENTICATION__MUTATIONS } from "@/store/mutation-types";
import SocialIcons from "./SocialIcons.vue";
import toast from "@/services/Notification";

export default {
  components: { LanguageMenu, SocialIcons },
  data: () => ({
    genInfo: {},
    loading: false,
    ex4: false,
  }),
  computed: {
    ...mapState("publicinfo", ["info"]),

    ...mapState("authentication", ["loginInfo", "viewPassword"]),

    ...mapGetters("authentication", ["validToLogin"]),

    logoSrc() {
      return this.$vuetify.theme.light ? this.info?.logo_url : this.info?.logo_url_dark;
    },

    companyName() {
      return this.info?.company_name || "Forex Crm";
    },

    logoWidth() {
      return this.info?.logo_width || "100%";
    },

    logoHeight() {
      return this.info?.logo_height || "100%";
    },
  },
  methods: {
    ...mapMutations("authentication", {
      LOGIN_EMAIL: AUTHENTICATION__MUTATIONS.LOGIN_EMAIL,
      LOGIN_PASSWORD: AUTHENTICATION__MUTATIONS.LOGIN_PASSWORD,
      VIEW_PASSWORD: AUTHENTICATION__MUTATIONS.VIEW_PASSWORD,
    }),

    ...mapActions("authentication", {
      LOGIN: AUTHENTICATION__ACTIONS.LOGIN,
      VERIFY_TWOFA_LOGIN: "VERIFY_TWOFA_LOGIN", // ✅ store action we added
    }),

    // async userLogin() {
    //   this.loading = true;
    //   try {
    //     const res = await this[AUTHENTICATION__ACTIONS.LOGIN]();

    //     // ✅ If 2FA required, store will set twoFaLogin + we open dialog
    //     if (res?.two_fa_required === true) {
    //       this.twoFaDialog = true;
    //       return;
    //     }
    //   } catch (error) {
    //     toast.error("Login failed. Please try again.");
    //     return;
    //   } finally {
    //     this.loading = false;
    //   }
    // },

   async userLogin() {
  this.loading = true;
  try {
    const res = await this.LOGIN();

    console.log("LOGIN RESPONSE:", res);
    console.log(
      "2FA STATE:",
      this.$store.state.authentication.twoFaLogin
    );

    // ✅ 2FA required → redirect
    if (res?.two_fa_required === true) {
      this.$router.push("/2fa"); // or "/two-fa" (check router)
      return;
    }

    // ✅ normal login
    this.$router.push("/dashboard");

  } catch (error) {
    console.error(error);
    toast.error("Login failed. Please try again.");
  } finally {
    this.loading = false;
  }
},



    

 

    ...mapActions("publicinfo", [PUBLIC_LOGIN__ACTIONS.LOGINPAGEINFO]),
  },

  async mounted() {
    await this[PUBLIC_LOGIN__ACTIONS.LOGINPAGEINFO]();
    this.genInfo = this.info;

    if (this.$route.params.verify == 1) {
      toast.success("Your account is successfully verified");
    }
    if (this.$route.params.verify == 2) {
      toast.error("Your account has been verified already");
    }
  },

  async created() {
    await this[PUBLIC_LOGIN__ACTIONS.LOGINPAGEINFO]();
    this.genInfo = this.info;
  },
};
</script>
